import * as React from "react";
import { Cloud } from "../../Cloud";
import { Clouds } from "../../Clouds";
import { SERVICES_CLOUDS_POS } from "../constants";
import { makeSphericalDistribute } from "../utils";

type Props = {
  spherical: Float32Array;
  segments: number;
  active: boolean;
};

export function ServicesPart({ spherical, segments, active }: Props) {
  const opacity = active ? 0.78 : 0.1;
  return (
    <group>
      <ambientLight intensity={1.0} />
      <hemisphereLight color="#ffffff" groundColor="#fff" intensity={1.0} />
      <directionalLight intensity={0.6} position={[0, 300, -300]} castShadow />
      <pointLight position={[0, 50, 50]} intensity={1.2} color="#82A5C7" />
      <Clouds scale={3.25} limit={segments} position={SERVICES_CLOUDS_POS}>
        <Cloud
          segments={segments}
          seed={2}
          volume={175}
          growth={260}
          smallestVolume={0.85}
          bounds={320}
          opacity={opacity}
          speed={0.07}
          color="#1a2c4a"
          concentrate="random"
          distribute={makeSphericalDistribute(spherical, {
            yMul: 0.75,
            yAdd: 0.2,
            zMul: 1.05,
          })}
        />
      </Clouds>
    </group>
  );
}
